<div class="list">
  <div *ngFor="let date of dates" class="date-container">
    <span class="date">{{date.date | relativeDate}}</span>
    <div class="exams-list">
      <div *ngFor="let exam of date.exams; let last = last">
        <div class="exam" (click)="handleExamClick(exam)">
          <span class="name">Probeklausur</span>
          <span class="score">
            <ng-container *ngIf="exam.score">{{exam.score}}%</ng-container>
            <ng-container *ngIf="!exam.score">Unvollständig</ng-container>
          </span>
        </div>
        <div *ngIf="!last" class="divider"></div>
      </div>
    </div>
  </div>
</div>